import { html } from 'lit';
import componentStyles from './cta-featured.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import { classMap } from 'lit-html/directives/class-map';
import {slugify} from '../../utils/string.js';

/**
 * Call to Action Featured card for landing pages.
 *
 * @element hf-cta-featured
 */
export default class CtaFeatured extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * Image alignment
       * @type {gray-purple|white-gray}
       */
      colorStyle: { type: String },
      /**
       * Image alignment
       * @type {right|left}
       */
      imageAlignment: { type: String },
      items: { type: Object },
      nextSteps: { type: Object },
    };
  }

  constructor() {
    super();
    this.nextSteps = [];
  }

  render() {
    return html`
      <div
        class="${classMap({
          'cta-featured': true,
          [`cta-featured--${this.colorStyle}`]: true,
        })}"
      >
        ${this.items.map((item, index) => {
          const parity = index % 2 ? 'even' : 'odd';
          const alignment =
            (index % 2 === 1 && this.imageAlignment === 'right') ||
            (index % 2 === 0 && this.imageAlignment === 'left')
              ? 'right'
              : 'left';
          return html`<div
            class="${classMap({
              'cta-featured__item': true,
              [`cta-featured--${parity}`]: true,
              [`cta-featured--image-${alignment}`]: true,
            })}"
          >
            <div class="cta-featured__image">
              <hf-responsive-image
                imageStyle="cta-featured"
              >
                <div slot="image">
                  <slot name="image${index}"></slot>
                </div>
              </hf-responsive-image>
            </div>
            <div class="cta-featured__content">
              <hf-heading
                level="2"
                levelStyle="heading2"
                id="${slugify(item.title)}"
                class="cta-featured__title"
              >
                ${item.title}
              </hf-heading>
              <p class="cta-featured__text">${item.text}</p>
              <div class="cta-featured__link">
                ${(item.link &&
                  item.link.url &&
                  html`
                    <hf-link-button
                      ignoreExternalUrl
                      href="${item.link.url}"
                      target=${item.link.target ? item.link.target : '_self'}
                      arialabelledby="${slugify(item.link.text)} ${slugify(item.title)}"
                      id="${slugify(item.link.text)}"
                      icon="${item.link.icon}"
                      iconDirection="${item.link.iconDirection}"
                      linkClass="btn__link--cta-featured--${this
                        .colorStyle}--${parity}"
                      >${item.link.text}</hf-link-button
                    >
                  `) ||
                ''}
              </div>
            </div>
          </div>`;
        })}
      </div>
    `;
  }
}

customElements.define('hf-cta-featured', CtaFeatured);
